module.exports = __webpack_public_path__ + "img/Drivers_Social_Values.97c2fe35.jpg";